import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "fundingP startupHubP sec-main pt-0",
  id: "main"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"fundingP-hero\"><div class=\"container-fluid\"><div class=\"row text-center\"><div class=\"col-12 g-0\"><picture><source srcset=\"resources/images/startup_hub/banner-startup-hub_web.jpg\" alt=\"新竹社會創新基地\" media=\"(min-width: 768px)\"><img srcset=\"resources/images/startup_hub/banner-startup-hub_mobile.jpg\" alt=\"新竹社會創新基地\" class=\"d-block img-fluid mx-auto\" width=\"1440\"></picture></div></div></div></section>", 1)
const _hoisted_3 = { class: "fundingP-main" }
const _hoisted_4 = { class: "container-lg" }
const _hoisted_5 = { class: "col-sm-10 mx-auto" }
const _hoisted_6 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, "新創計畫 - 社創基地", -1)
const _hoisted_10 = { class: "col-12 mx-auto fundingP-board px-3 py-md-5 px-md-0 bg-gray" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "filter-tabs" }, [
  /*#__PURE__*/_createElementVNode("ul", {
    class: "nav justify-content-center",
    id: "startupHub-tab",
    role: "tablist"
  }, [
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "nav-link tab-underline active",
        id: "startupHub1-tab",
        "data-bs-toggle": "pill",
        "data-bs-target": "#startupHub1",
        type: "button",
        role: "tab",
        "aria-controls": "startupHub1",
        "aria-selected": "true"
      }, "基地介紹")
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "nav-link tab-underline",
        id: "startupHub3-tab",
        "data-bs-toggle": "pill",
        "data-bs-target": "#startupHub3",
        type: "button",
        role: "tab",
        "aria-controls": "startupHub3",
        "aria-selected": "false"
      }, "活動消息")
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "nav-link tab-underline",
        id: "startupHub4-tab",
        "data-bs-toggle": "pill",
        "data-bs-target": "#startupHub4",
        type: "button",
        role: "tab",
        "aria-controls": "startupHub4",
        "aria-selected": "false"
      }, "進駐團隊介紹")
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "nav-link tab-underline",
        id: "startupHub2-tab",
        "data-bs-toggle": "pill",
        "data-bs-target": "#startupHub2",
        type: "button",
        role: "tab",
        "aria-controls": "startupHub2",
        "aria-selected": "false"
      }, "場地租借")
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "nav-link tab-underline",
        id: "startupHub5-tab",
        "data-bs-toggle": "pill",
        "data-bs-target": "#startupHub5",
        type: "button",
        role: "tab",
        "aria-controls": "startupHub5",
        "aria-selected": "false"
      }, "成果與花絮")
    ])
  ])
], -1)
const _hoisted_12 = {
  class: "tab-content",
  id: "startupHub-tabContent"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "visually-hidden" }, "社創基地", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade show active",
  id: "startupHub1",
  role: "tabpanel",
  "aria-labelledby": "startupHub1-tab",
  tabindex: "0"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-10 mx-auto" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "h2 mb-md-3 mb-2" }, "新竹社會創新基地"),
        /*#__PURE__*/_createElementVNode("p", { class: "h4" }, [
          /*#__PURE__*/_createTextVNode(" 新竹社會創新基地為新竹縣政府推動青年創業與社會創新的據點。基地占地460坪，具獨立辦公室、共享工作空間、活動與會議場域等，提供多元使用選擇，並搭配培力課程、專業顧問輔導及跨域交流活動，支持在地青年、社會企業及創生團隊成長。 "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" 基地持續推動創業培育與資源媒合，協助團隊將創意轉化為具體行動，並結合聯合國永續發展目標，實踐社會影響力。這裡不僅是工作的場域，更是激發創意、共創價值的平台，也邀請更多夥伴一同加入，為竹縣注入創新與永續的能量。 ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "h2 mb-md-3 mb-2" }, "進駐資格"),
        /*#__PURE__*/_createElementVNode("p", { class: "h4" }, " 對社會福利、社會企業、社區營造、青年創業或多元議題（如：銀髮及青銀共創、綠能環保、新住民、教育等議題）有興趣之個人、團隊、營利組織及非營利組織。 "),
        /*#__PURE__*/_createElementVNode("ul", {
          class: "h4",
          style: {"list-style-type":"decimal"}
        }, [
          /*#__PURE__*/_createElementVNode("li", null, "個人、尚未設立登記之團體：戶籍或工作地於新竹縣者為優先。"),
          /*#__PURE__*/_createElementVNode("li", null, "營利組織(企業、公司、行號、工作室等)：登記地址或營業所設於新竹縣者為優先。"),
          /*#__PURE__*/_createElementVNode("li", null, "非營利組織（協會、基金會等）：會址設於新竹縣者為優先。")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "h2 mb-md-3 mb-2" }, "聯絡資訊"),
        /*#__PURE__*/_createElementVNode("ul", { class: "h4 list-unstyled" }, [
          /*#__PURE__*/_createElementVNode("li", null, "Email：hsh1120201@gmail.com"),
          /*#__PURE__*/_createElementVNode("li", null, "LINE：@164hsdvt"),
          /*#__PURE__*/_createElementVNode("li", null, "電話：03-5593142分機3514"),
          /*#__PURE__*/_createElementVNode("li", null, "地址：新竹縣竹北市中山路220號3樓(同心樓)")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "h2 mb-md-3 mb-2" }, "所屬單位"),
        /*#__PURE__*/_createElementVNode("ul", { class: "h4 list-unstyled" }, [
          /*#__PURE__*/_createElementVNode("li", null, "指導單位：新竹縣政府、新竹縣議會"),
          /*#__PURE__*/_createElementVNode("li", null, "主辦單位：新竹縣政府教育局"),
          /*#__PURE__*/_createElementVNode("li", null, "執行單位：明新學校財團法人明新科技大學")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "h2 mb-md-3 mb-2" }, "交通方式"),
        /*#__PURE__*/_createElementVNode("ul", {
          class: "h4",
          style: {"list-style-type":"decimal"}
        }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode("自行開車前往 "),
            /*#__PURE__*/_createElementVNode("ul", { class: "list-unstyled" }, [
              /*#__PURE__*/_createElementVNode("li", null, "(1)國道1號／中山高速公路：從「竹北交流道」下，往竹北市區方向（光明六路／縣政二路）行駛約5分鐘，即可抵達中山路。"),
              /*#__PURE__*/_createElementVNode("li", null, "(2)國道3號：從「竹林交流道」下，接台68線往竹北方向，沿中正東路與中山路行駛約10分鐘即可抵達。")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode("搭乘高鐵／火車前往 "),
            /*#__PURE__*/_createElementVNode("ul", { class: "list-unstyled" }, [
              /*#__PURE__*/_createElementVNode("li", null, "(1)高鐵新竹站（六家站）：搭乘高鐵快捷公車5900至「竹北火車站」，出站後沿中山路步行約10分鐘即可抵達。或搭乘計程車約5分鐘）"),
              /*#__PURE__*/_createElementVNode("li", null, "(2)台鐵竹北站：出站後直行中山路往縣政府方向，步行約8～10分鐘即可到達基地。")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode("大眾公車前往 "),
            /*#__PURE__*/_createElementVNode("ul", { class: "list-unstyled" }, [
              /*#__PURE__*/_createElementVNode("li", null, "可搭乘客運／市區公車至「婦幼館站」、「十興路站」、「北和宮」、「水瓏」、「竹北一」，下車後步行約3分鐘即可抵達。")
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("p", { class: "h4" }, " 主要路線包含：快捷1、7、竹北市民公車60、61、新竹客運5619、5620號線 "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("div", {
          class: "mx-auto",
          style: {"max-width":"823px"}
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-16x9" }, [
            /*#__PURE__*/_createElementVNode("iframe", {
              src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3620.786467332252!2d121.01857899999999!3d24.836974999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34683785d27514b5%3A0x18c31e26e5ace649!2z5paw56u557ij6Lqr5b-D6Zqc56SZ57ac5ZCI56aP5Yip5pyN5YuZ5Lit5b-DICjlkIzlv4PmqJMp!5e0!3m2!1szh-TW!2stw!4v1763363648983!5m2!1szh-TW!2stw",
              width: "100%",
              height: "auto",
              style: {"border":"0"},
              allowfullscreen: "",
              loading: "lazy",
              referrerpolicy: "no-referrer-when-downgrade"
            })
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "h2 mb-md-3 mb-2" }, "空間照片"),
        /*#__PURE__*/_createElementVNode("div", { class: "row hub-space-group row-cols-2" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col mb-3 px-md-2 px-1" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-hub" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "resources/images/startup_hub/大樓外觀.png",
                alt: "大樓外觀",
                class: "img-fluid"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h5 text-center mt-1" }, "大樓外觀")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col mb-3 px-md-2 px-1" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-hub" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "resources/images/startup_hub/共享工作空間3.png",
                alt: "共享工作空間",
                class: "img-fluid"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h5 text-center mt-1" }, "共享工作空間")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col mb-3 px-md-2 px-1" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-hub" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "resources/images/startup_hub/共享工作空間2.png",
                alt: "共享工作空間",
                class: "img-fluid"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h5 text-center mt-1" }, "共享工作空間")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col mb-3 px-md-2 px-1" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-hub" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "resources/images/startup_hub/共享工作空間.png",
                alt: "共享工作空間",
                class: "img-fluid"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h5 text-center mt-1" }, "共享工作空間")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col mb-3 px-md-2 px-1" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-hub" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "resources/images/startup_hub/獨立工作空間.png",
                alt: "獨立工作空間",
                class: "img-fluid"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h5 text-center mt-1" }, "獨立工作空間")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col mb-3 px-md-2 px-1" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-hub" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "resources/images/startup_hub/培訓互動教室.png",
                alt: "培訓互動教室",
                class: "img-fluid"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h5 text-center mt-1" }, "培訓互動教室")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col mb-3 px-md-2 px-1" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-hub" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "resources/images/startup_hub/會議室.png",
                alt: "會議室",
                class: "img-fluid"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h5 text-center mt-1" }, "會議室")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col mb-3 px-md-2 px-1" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-hub" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "resources/images/startup_hub/茶水區.png",
                alt: "茶水區",
                class: "img-fluid"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h5 text-center mt-1" }, "茶水區")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_15 = {
  class: "tab-pane fade",
  id: "startupHub4",
  role: "tabpanel",
  "aria-labelledby": "startupHub4-tab",
  tabindex: "0"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-10 mx-auto" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 head-row" }, "進駐團隊介紹", -1)
const _hoisted_19 = { class: "row row-cols-1 row-cols-sm-2 row-cols-md-3 cols-list team-list" }
const _hoisted_20 = { class: "team-item border bg-white h-100 p-0" }
const _hoisted_21 = ["onClick", "title"]
const _hoisted_22 = { class: "team-card-logo" }
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = { class: "team-card-info px-3 py-1 border-top text-center" }
const _hoisted_25 = { class: "h6 team-card-name text-primary mb-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "h5 text-decoration-underline text-link-gray" }, "完整介紹", -1)
const _hoisted_27 = {
  class: "tab-pane fade",
  id: "startupHub3",
  role: "tabpanel",
  "aria-labelledby": "startupHub3-tab",
  tabindex: "0"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-10 mx-auto" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 head-row" }, "活動消息", -1)
const _hoisted_31 = { class: "row row-cols-1 row-cols-sm-2 row-cols-lg-3 cols-list event-list" }
const _hoisted_32 = { class: "event-item bg-white h-100 p-0" }
const _hoisted_33 = { class: "event-card-logo" }
const _hoisted_34 = { class: "event-card-info p-3 border-top" }
const _hoisted_35 = { class: "event-card-date info-text mb-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "event-card-cate text-primary mb-2" }, "近期活動", -1)
const _hoisted_37 = { class: "h5 event-card-title limitLine mb-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "tiny-link" }, [
  /*#__PURE__*/_createElementVNode("u", null, "了解更多")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "startupHub2",
  role: "tabpanel",
  "aria-labelledby": "startupHub2-tab",
  tabindex: "0"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-10 mx-auto" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-md-3 mb-2" }, "場地租借"),
        /*#__PURE__*/_createElementVNode("ul", {
          class: "h4",
          style: {"list-style-type":"decimal"}
        }, [
          /*#__PURE__*/_createElementVNode("li", null, "會議室(E)：空間可容納20人，進駐者每小時300元，非進駐者每小時600元。"),
          /*#__PURE__*/_createElementVNode("li", null, "展覽活動空間(C)：空間可容納100人，進駐者每小時700元，非進駐者每小時1,400元。"),
          /*#__PURE__*/_createElementVNode("li", null, "培訓互動教室(F)：空間可容納10人，進駐者每小時200元，非進駐者每小時400元。"),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode("申請場地租借請於使用10日前填寫申請表(請下載附表一)，並 mail 至 "),
            /*#__PURE__*/_createElementVNode("a", { href: "mailto:hsh1120201@gmail.com" }, "hsh1120201@gmail.com"),
            /*#__PURE__*/_createTextVNode("。")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-md-3 mb-2" }, "使用規則"),
        /*#__PURE__*/_createElementVNode("ul", {
          class: "h4",
          style: {"list-style-type":"decimal"}
        }, [
          /*#__PURE__*/_createElementVNode("li", null, "配合基地營運時間，所有場地週日及國定假日不對外開放。"),
          /*#__PURE__*/_createElementVNode("li", null, "本規範所稱進駐者，係指進駐新竹縣政府轄下新竹青年創業基地及新竹社會創新基地之對象。"),
          /*#__PURE__*/_createElementVNode("li", null, "本基地全面禁菸。"),
          /*#__PURE__*/_createElementVNode("li", null, "場地借用不提供桌椅及場佈，另請自備筆電、無線麥克風電池、環保杯、垃圾袋等消耗性用品。"),
          /*#__PURE__*/_createElementVNode("li", null, "使用人逾時使用場地，依超時時間加收費用，每逾時1小時加收1小時之費用，逾時未滿1小時者，加收每小時二分之一之費用。")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-md-3 mb-2" }, "聯絡資訊"),
        /*#__PURE__*/_createElementVNode("ul", { class: "h4 list-unstyled" }, [
          /*#__PURE__*/_createElementVNode("li", null, "Email：hsh1120201@gmail.com"),
          /*#__PURE__*/_createElementVNode("li", null, "LINE：@164hsdv"),
          /*#__PURE__*/_createElementVNode("li", null, "電話：03-5593142分機3514")
        ]),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("img", {
          src: "resources/images/startup_hub/空間分布圖.png",
          alt: "空間分布圖",
          class: "img-fluid"
        }),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("div", { class: "row hub-space-group row-cols-3" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col mb-3 px-md-2 px-1" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-hub" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "resources/images/startup_hub/展覽活動空間（Ｃ）.png",
                alt: "展覽活動空間（Ｃ）",
                class: "img-fluid"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h5 text-center mt-1" }, "展覽活動空間（Ｃ）")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col mb-3 px-md-2 px-1" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-hub" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "resources/images/startup_hub/培訓互動教室（Ｅ）.png",
                alt: "培訓互動教室（Ｅ）",
                class: "img-fluid"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h5 text-center mt-1" }, "培訓互動教室（Ｅ）")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col mb-3 px-md-2 px-1" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-hub" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "resources/images/startup_hub/會議室（Ｆ）.png",
                alt: "會議室（Ｆ）",
                class: "img-fluid"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h5 text-center mt-1" }, "會議室（Ｆ）")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-md-3 mb-2" }, "可預約時段"),
        /*#__PURE__*/_createElementVNode("div", {
          class: "mx-auto",
          style: {"max-width":"800px"}
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-4x3" }, [
            /*#__PURE__*/_createElementVNode("iframe", {
              src: "https://calendar.google.com/calendar/embed?src=hhsihub1017%40gmail.com&ctz=Asia%2FTaipei",
              style: {"border":"0"},
              width: "800",
              height: "600",
              frameborder: "0",
              scrolling: "no"
            })
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "h2 mb-md-3 mb-2" }, "表單下載"),
        /*#__PURE__*/_createElementVNode("p", { class: "h4" }, [
          /*#__PURE__*/_createTextVNode("新竹社會創新基地場地使用管理規範(含場地借用申請表)"),
          /*#__PURE__*/_createElementVNode("a", {
            href: "resources/新竹社會創新基地場地使用管理規範.pdf",
            class: "btn-primay has-icon filled icon-link ms-2",
            title: "另開新視窗",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "管理規範下載")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_40 = {
  class: "tab-pane fade",
  id: "startupHub5",
  role: "tabpanel",
  "aria-labelledby": "startupHub5-tab",
  tabindex: "0"
}
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-md-10 mx-auto" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 head-row" }, "成果與花絮", -1)
const _hoisted_44 = {
  key: 0,
  class: "row row-cols-1 cols-list event-list"
}
const _hoisted_45 = { class: "event-item bg-white p-0 border" }
const _hoisted_46 = { class: "event-card-logo flex-shrink-0" }
const _hoisted_47 = { class: "event-card-info p-3 flex-grow-1 fcsb" }
const _hoisted_48 = { class: "h3 event-card-title text-primary mb-2" }
const _hoisted_49 = { class: "h5 event-card-des limitLine" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "h5 text-link-gray mt-md-0 mt-3" }, [
  /*#__PURE__*/_createElementVNode("u", null, "了解更多")
], -1)
const _hoisted_51 = { class: "frcc" }
const _hoisted_52 = {
  class: "modal fade",
  id: "hubTeamModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_53 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_54 = { class: "modal-content" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "ms-auto" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_56 = {
  key: 0,
  class: "company-intro-main text-center"
}
const _hoisted_57 = { class: "mb-1" }
const _hoisted_58 = { class: "h4 mb-3" }
const _hoisted_59 = ["href"]
const _hoisted_60 = /*#__PURE__*/_createStaticVNode("<div class=\"modal fade\" id=\"hubGalleryModal\" tabindex=\"-1\" aria-hidden=\"true\" data-bs-backdrop=\"true\"><div class=\"modal-dialog modal-xl modal-dialog-centered\"><div class=\"modal-content text-white border-0\"><div class=\"modal-body p-0\"><div class=\"hub-gallery-main position-relative\"><div class=\"ratio ratio-hub\"><img id=\"hubGalleryMainImg\" src=\"\" alt=\"\" class=\"w-100 d-block\"></div><button type=\"button\" class=\"hub-gallery-prev btn btn-sm position-absolute top-50 translate-middle-y\"></button><button type=\"button\" class=\"hub-gallery-next btn btn-sm position-absolute top-50 translate-middle-y\"></button></div><div class=\"hub-gallery-caption text-center\" id=\"hubGalleryCaption\"></div><div class=\"hub-gallery-thumbs d-flex overflow-auto py-2 px-1 gap-2\" id=\"hubGalleryThumbs\"></div></div></div></div></div>", 1)

import {onMounted, ref} from 'vue'
import {useRoute} from 'vue-router'
import {RestService} from '../service/rest.service'
import PaginationComponent from '@/components/pagination/PaginationComponent.vue'

declare const $: any
declare const bootstrap: any


export default /*#__PURE__*/_defineComponent({
  __name: 'startupHubView',
  setup(__props) {

const route = useRoute()
const hubEvents = ref<any[]>([])
const hubEventsService = new RestService('hub/events')
const hubTeams = ref<any[]>([])
const hubTeamsService = new RestService('hub/teams')
const selectedTeam = ref<any>(null)
const hubHighlights = ref<any[]>([])
const totalHubHighlightPages = ref(0)
const hubHighlightsService = new RestService('hub/highlights')

onMounted(() => {
  // 載入社創基地活動消息
  hubEventsService.gets().then((data: any) => {
    hubEvents.value = data
  })

  // 載入社創基地進駐團隊
  hubTeamsService.gets().then((data: any) => {
    hubTeams.value = data
  })

  // 載入社創基地成果與花絮
  loadHubHighlights(1)

  // 依 ?tab 參數自動切換頁籤
  const tabMap: Record<string, string> = {
    events: '#startupHub3-tab',
    highlights: '#startupHub5-tab'
  }
  const tabQuery = route.query.tab as string
  if (tabQuery && tabMap[tabQuery] && typeof bootstrap !== 'undefined') {
    const tabEl = document.querySelector(tabMap[tabQuery]) as HTMLElement | null
    if (tabEl) new bootstrap.Tab(tabEl).show()
  }
  // 下面是你原本的 jQuery simpleScrollFollow
  if (typeof $ !== 'undefined' && $('#funding-tab').length) {
    $('#funding-tab').simpleScrollFollow({
      upper_side: 'nav.navbar',
      lower_side: 'footer'
    })
  }

  const modalEl = document.getElementById('hubGalleryModal')
  if (modalEl && typeof bootstrap !== 'undefined') {
    const modal = new bootstrap.Modal(modalEl, {
      backdrop: 'static',
      keyboard: true
    })

    const mainImg = document.getElementById('hubGalleryMainImg') as HTMLImageElement | null
    const captionEl = document.getElementById('hubGalleryCaption') as HTMLElement | null
    const thumbsContainer = document.getElementById('hubGalleryThumbs') as HTMLElement | null

    const prevBtn = modalEl.querySelector('.hub-gallery-prev') as HTMLButtonElement | null
    const nextBtn = modalEl.querySelector('.hub-gallery-next') as HTMLButtonElement | null

    if (!mainImg || !captionEl || !thumbsContainer) return

    const MAX_THUMBS = 8
    let currentImagesData: Array<{ src: string; alt: string; title: string }> = []
    let currentIndex = 0

    // ⬇⬇⬇ 這三個改成 const + arrow function ⬇⬇⬇
    const buildImagesDataFromGroup = (groupEl: Element) => {
      const imgs = Array.from(groupEl.querySelectorAll('img'))
      return imgs.map((img) => {
        const col = img.closest('.col')
        const title = col ? (col.querySelector('.h5')?.textContent?.trim() || '') : ''
        return {
          src: img.getAttribute('src') || '',
          alt: img.getAttribute('alt') || '',
          title
        }
      })
    }

    const renderThumbs = () => {
      thumbsContainer.innerHTML = ''

      if (!currentImagesData.length) return
      const thumbsData = currentImagesData.slice(0, MAX_THUMBS)

      thumbsData.forEach((imgData, idx) => {
        const btn = document.createElement('button')
        btn.type = 'button'
        btn.className = 'border-0 bg-transparent p-0'

        const thumbImg = document.createElement('img')
        thumbImg.src = imgData.src
        thumbImg.alt = imgData.alt
        thumbImg.className = 'img-fluid'

        btn.appendChild(thumbImg)

        btn.addEventListener('click', () => {
          showIndex(idx)
        })

        thumbsContainer.appendChild(btn)
      })
    }

    const showIndex = (idx: number) => {
      const total = currentImagesData.length
      if (!total) return

      if (idx < 0) {
        idx = total - 1
      } else if (idx >= total) {
        idx = 0
      }

      currentIndex = idx
      const data = currentImagesData[currentIndex]

      mainImg.src = data.src
      mainImg.alt = data.alt
      captionEl.textContent = data.title || data.alt || ''

      const thumbsImgs = thumbsContainer.querySelectorAll('img')
      thumbsImgs.forEach((thumb, i) => {
        thumb.classList.toggle('hub-thumb-active', i === currentIndex)
      })
    }

    // 綁定每一組 .hub-space-group 裡的圖片，點擊開 modal
    const groups = document.querySelectorAll('.hub-space-group')
    groups.forEach((groupEl) => {
      const imgs = groupEl.querySelectorAll('img')
      if (!imgs.length) return

      imgs.forEach((imgEl, indexInGroup) => {
        const img = imgEl as HTMLImageElement
        img.style.cursor = 'pointer'

        img.addEventListener('click', () => {
          // 每次點擊同一組的任一張，就重建該組的資料
          currentImagesData = buildImagesDataFromGroup(groupEl)

          // 渲染縮圖
          renderThumbs()

          // 顯示被點擊的那張
          showIndex(indexInGroup)

          // 開啟 modal
          modal.show()
        })
      })
    })

    // 上一張 / 下一張
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        showIndex(currentIndex - 1)
      })
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        showIndex(currentIndex + 1)
      })
    }

    // 點黑色遮罩關閉 modal
    modalEl.addEventListener('click', (e: MouseEvent) => {
      const dialog = modalEl.querySelector('.modal-dialog') as HTMLElement | null
      if (dialog && !dialog.contains(e.target as Node)) {
        modal.hide()
      }
    })
  }

  // 下面是你原本的 jQuery simpleScrollFollow（保留，避免破壞原有功能）
  /**
   * jQuery simpleScrollFollow
   * 原本是 $(function () { ... })，在 Vue 裡改成 onMounted 即可
   */
  if (typeof $ !== 'undefined' && $('#funding-tab').length) {
    $('#funding-tab').simpleScrollFollow({
      upper_side: 'nav.navbar',
      lower_side: 'footer'
    })
  }
})

function loadHubHighlights(page: number) {
  hubHighlightsService.gets({page}).then((data: any) => {
    hubHighlights.value = data.content
    totalHubHighlightPages.value = data.totalPages
  })
}

function changeHubHighlightPage(page: number) {
  loadHubHighlights(page)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_title = _resolveDirective("title")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("main", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("nav", _hoisted_6, [
              _createElementVNode("ol", _hoisted_7, [
                _createElementVNode("li", _hoisted_8, [
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                      _createTextVNode("首頁")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_9
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hubTeams.value, (team) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: team.id,
                          class: "col align-self-stretch mb-4"
                        }, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (selectedTeam.value = team),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#hubTeamModal",
                              role: "button",
                              title: team.name
                            }, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("img", {
                                  class: "img-fluid",
                                  src: team.file ? team.file.path : '',
                                  alt: team.name
                                }, null, 8, _hoisted_23)
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, _toDisplayString(team.name), 1),
                                _hoisted_26
                              ])
                            ], 8, _hoisted_21)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hubEvents.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "col align-self-stretch mb-4"
                        }, [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_router_link, {
                              to: {name: 'hub-event-detail', params: { id: item.id }},
                              title: item.name
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", {
                                    class: "bg-wrapper",
                                    style: _normalizeStyle('background-image: url(' + (item.file1 ? item.file1.path : '/resources/images/placeholder-event.png') + ')')
                                  }, null, 4)
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", _hoisted_35, _toDisplayString(item.date), 1),
                                  _hoisted_36,
                                  _createElementVNode("div", _hoisted_37, _toDisplayString(item.name), 1),
                                  _hoisted_38
                                ])
                              ]),
                              _: 2
                            }, 1032, ["to", "title"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    (hubHighlights.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hubHighlights.value, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: "col align-self-stretch mb-4"
                            }, [
                              _createElementVNode("div", _hoisted_45, [
                                _createVNode(_component_router_link, {
                                  to: {name: 'hub-highlight-detail', params: { id: item.id }},
                                  class: "frths",
                                  title: item.name
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_46, [
                                      _createElementVNode("div", {
                                        class: "bg-wrapper",
                                        style: _normalizeStyle('background-image: url(' + (item.file ? item.file.path : '') + ');')
                                      }, null, 4)
                                    ]),
                                    _createElementVNode("div", _hoisted_47, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_48, _toDisplayString(item.name), 1),
                                        _createElementVNode("p", _hoisted_49, _toDisplayString(item.description), 1)
                                      ]),
                                      _hoisted_50
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["to", "title"])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(PaginationComponent, {
                        class: "pagination-component",
                        totalPages: totalHubHighlightPages.value,
                        onOnClick: changeHubHighlightPage
                      }, null, 8, ["totalPages"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])), [
      [_directive_title, '社創基地']
    ]),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _hoisted_55,
          (selectedTeam.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("h3", _hoisted_57, _toDisplayString(selectedTeam.value.name), 1),
                _createElementVNode("p", _hoisted_58, _toDisplayString(selectedTeam.value.description), 1),
                (selectedTeam.value.website)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: selectedTeam.value.website,
                      class: "btn-primay has-icon filled square-arrow",
                      title: "另開新視窗",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, "官方網站", 8, _hoisted_59))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_60
  ], 64))
}
}

})